/**
 * Send an error to Datadog RUM and Datadog Logs if available (never throws).
 *
 * Uses window globals (DD_RUM, DD_LOGS) so sparkle doesn't need to depend
 * on @datadog/browser-rum or @datadog/browser-logs.
 */
export function reportToDatadog(error, context) {
    var _a, _b, _c;
    try {
        const ddRum = window.DD_RUM;
        (_a = ddRum === null || ddRum === void 0 ? void 0 : ddRum.addError) === null || _a === void 0 ? void 0 : _a.call(ddRum, error, context);
    }
    catch (_d) {
        // Fail-safe: Datadog may not be loaded yet.
    }
    try {
        const ddLogs = window.DD_LOGS;
        const message = error instanceof Error ? error.message : String(error);
        (_c = (_b = ddLogs === null || ddLogs === void 0 ? void 0 : ddLogs.logger) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.call(_b, message, context);
    }
    catch (_e) {
        // Fail-safe: Datadog Logs may not be initialized.
    }
}
//# sourceMappingURL=reportToDatadog.js.map